import axios from 'axios';
import {
	createContext,
	useCallback,
	useState,
	useSyncExternalStore,
} from 'react';
import API from 'services/api';

export const MessageContext = createContext({});

const MessageProvider = props => {
	const [inboxMsg, setInboxMsg] = useState([]);
	const [sentMsg, setSentMsg] = useState([]);
	const [draftMsg, setDraftMsg] = useState([]);
	const [inboxFilterMsg, setInboxFilterMsg] = useState([]);
	const [sentFilterMsg, setSentFilterMsg] = useState([]);
	const [draftFilterMsg, setDraftFilterMsg] = useState([]);
	const [checked, setChecked] = useState([]);
	const [labelsMsg, setLabelsMsg] = useState([]);
	const [toggleAll, setToggleAll] = useState('');
	const [filterLabel, setFilterLabel] = useState('');
	const [valueTab, setValueTab] = useState(0);

	const generateOCRImgToJSON = data => {
		return API.postConvertImgToJsonOCR(data)
			.then(res => {
				const { data } = res;
				return { status: 200, data: data };
			})
			.catch(err => {
				console.log('err', err);
				return { status: 404, data: err.message };
			});
	};

	const getLabels = email => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:
				'https://gmail.googleapis.com/gmail/v1/users/' +
				email +
				'/labels?key=' +
				process.env.REACT_APP_CLIENT_ID,
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('gmail_token'),
			},
		};

		axios
			.request(config)
			.then(function (response) {
				const filtered = response.data?.labels?.filter(
					item => item.type === 'user'
				);
				setLabelsMsg(filtered);
			})
			.catch(err => console.error(err));
	};

	const handleToggle = (value, typeMsg) => {
		const uniqueArray =
			typeMsg === 'inbox'
				? inboxMsg.filter(
						(item, index, arr) =>
							arr.findIndex(prevItem => prevItem.id === item.id) === index
				  )
				: typeMsg === 'sent'
				? sentMsg.filter(
						(item, index, arr) =>
							arr.findIndex(prevItem => prevItem.id === item.id) === index
				  )
				: draftMsg.filter(
						(item, index, arr) =>
							arr.findIndex(prevItem => prevItem.id === item.id) === index
				  );

		if (Array.isArray(value) && value?.length > 1 && toggleAll !== 'all') {
			setToggleAll('all');
			let newChecked = value?.map(item => item.id);
			setChecked(newChecked);
		} else if (Array.isArray(value) && toggleAll === 'all') {
			setToggleAll('');
			setChecked([]);
		} else if (checked.includes(value)) {
			let newChecked = checked.filter(item => item !== value);
			// If the value already exists in the 'checked' array, remove it
			setToggleAll('');
			setChecked(newChecked);
		} else {
			let newChecked = [...checked];
			// If the value does not exist in 'checked', add it to the array
			newChecked.push(value);
			setChecked(newChecked);
			if (checked.length === uniqueArray.length - 1) {
				setToggleAll('all');
			}
		}
	};

	const updateMarkRead = (email, id) => {
		let config = {
			method: 'post',
			maxBodyLength: Infinity,
			url:
				'https://gmail.googleapis.com/gmail/v1/users/' +
				email +
				'/messages/' +
				id +
				'modify?key=' +
				process.env.REACT_APP_CLIENT_ID,
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('gmail_token'),
			},
			data: {},
		};

		axios
			.request(config)
			.then(function (response) {})
			.catch(err => console.error(err));
	};

	const getListThreads = email => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:
				'https://gmail.googleapis.com/gmail/v1/users/' +
				email +
				'/threads?key=' +
				process.env.REACT_APP_CLIENT_ID,
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('gmail_token'),
			},
		};

		axios
			.request(config)
			.then(function (response) {
				const listDataMessage = response.data.threads.filter(
					message => message.snippet !== ''
				);
				setInboxMsg(listDataMessage);
				setInboxFilterMsg(listDataMessage);
			})
			.catch(err => console.error(err));
	};

	const getDetailThread = async (email, id) => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:
				'https://gmail.googleapis.com/gmail/v1/users/' +
				email +
				'/threads/' +
				id +
				'?key=' +
				process.env.REACT_APP_CLIENT_ID,
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('gmail_token'),
			},
		};
		try {
			const response = await axios.request(config);
			return response.data;
		} catch (err) {
			return err;
			// throw err;
		}
	};

	const getDetailMessage = async (email, id) => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:
				'https://gmail.googleapis.com/gmail/v1/users/' +
				email +
				'/messages/' +
				id +
				'?key=' +
				process.env.REACT_APP_CLIENT_ID,
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('gmail_token'),
			},
		};
		try {
			const response = await axios.request(config);
			return response.data;
		} catch (err) {
			console.error(err);
			// throw err;
		}
	};

	const sendMessage = (
		from,
		headers_obj,
		message,
		typeMsg,
		dataAttachment,
		threadId
	) => {
		let email = '';

		for (const header in headers_obj) {
			email += `${header}: ${headers_obj[header]}\r\n`;
		}

		email += `Content-Type: multipart/mixed; boundary="boundary-example"\r\n`;
		email += `MIME-Version: 1.0\r\n\r\n`;
		email += `--boundary-example\r\n`;
		email += `Content-Type: text/html; charset="UTF-8"\r\n\r\n`;
		email += `<div dir="ltr">${message}</div>\r\n`;

		if (dataAttachment && dataAttachment.length > 0) {
			dataAttachment.forEach((attachment, index) => {
				email += `--boundary-example\r\n`;
				email += `Content-Type: application/octet-stream\r\n`;
				email += `MIME-Version: 1.0\r\n`;
				email += `Content-Disposition: attachment; filename="${attachment.filename}"\r\n`;
				email += `\r\n`;
				// Fetch attachment content and append it here

				const attachmentData = attachment.base64String;
				email += attachmentData + '\r\n';

				if (index === dataAttachment.length - 1) {
					email += `--boundary-example--\r\n`;
					const encodedEmail = window.btoa(unescape(encodeURIComponent(email)));

					const config = {
						method: 'post',
						maxBodyLength: Infinity,
						url: `https://gmail.googleapis.com/gmail/v1/users/${from}/messages/send?key=${process.env.REACT_APP_CLIENT_ID}`,
						data: {
							threadId,
							raw: encodedEmail
								.replace(/\+/g, '-')
								.replace(/\//g, '_')
								.replace(/=+$/, ''),
						},
						headers: {
							Authorization: `Bearer ${localStorage.getItem('gmail_token')}`,
						},
					};

					axios
						.request(config)
						.then(function (response) {
							if (typeMsg === 'inbox' || typeMsg === 'sent') {
								getListMessages(from, typeMsg);
							} else {
								getListDraft(from);
							}
							alert('Data berhasil dikirim');
						})
						.catch(err => alert('Error sending email: ' + err));
				}
			});
		} else {
			const encodedEmail = window.btoa(unescape(encodeURIComponent(email)));
			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `https://gmail.googleapis.com/gmail/v1/users/${from}/messages/send?key=${process.env.REACT_APP_CLIENT_ID}`,
				data: {
					threadId,
					raw: encodedEmail
						.replace(/\+/g, '-')
						.replace(/\//g, '_')
						.replace(/=+$/, ''),
				},
				headers: {
					Authorization: `Bearer ${localStorage.getItem('gmail_token')}`,
				},
			};
			axios
				.request(config)
				.then(function (response) {
					if (typeMsg === 'inbox' || typeMsg === 'sent') {
						getListMessages(from, typeMsg);
					} else {
						getListDraft(from);
					}
					alert('Data berhasil dikirim');
				})
				.catch(err => alert('Error sending email: ' + err));
		}
	};

	const sendDrafts = (from, headers_obj, message, dataAttachment) => {
		let email = '';

		for (const header in headers_obj) {
			email += `${header}: ${headers_obj[header]}\r\n`;
		}

		email += `Content-Type: multipart/mixed; boundary="boundary-example"\r\n`;
		email += `MIME-Version: 1.0\r\n\r\n`;
		email += `--boundary-example\r\n`;
		email += `Content-Type: text/html; charset="UTF-8"\r\n\r\n`;
		email += `<div dir="ltr">${message}</div>\r\n`;

		if (dataAttachment && dataAttachment.length > 0) {
			dataAttachment.forEach((attachment, index) => {
				email += `--boundary-example\r\n`;
				email += `Content-Type: application/octet-stream\r\n`;
				email += `MIME-Version: 1.0\r\n`;
				email += `Content-Disposition: attachment; filename="${attachment.filename}"\r\n`;
				email += `\r\n`;
				// Fetch attachment content and append it here

				const attachmentData = attachment.base64String;
				email += attachmentData + '\r\n';

				if (index === dataAttachment.length - 1) {
					email += `--boundary-example--\r\n`;
					const encodedEmail = window.btoa(unescape(encodeURIComponent(email)));

					const draftRequestBody = {
						message: {
							raw: encodedEmail
								.replace(/\+/g, '-')
								.replace(/\//g, '_')
								.replace(/=+$/, ''),
						},
					};

					const config = {
						method: 'post',
						maxBodyLength: Infinity,
						url: `https://gmail.googleapis.com/gmail/v1/users/${from}/drafts?key=${process.env.REACT_APP_CLIENT_ID}`,
						data: draftRequestBody,
						headers: {
							Authorization: `Bearer ${localStorage.getItem('gmail_token')}`,
						},
					};

					axios
						.request(config)
						.then(function (response) {
							alert('Drafts Berhasil Disimpan');
							// Optionally, retrieve the draft or perform other actions
						})
						.catch(err => alert('Error saving draft: ' + err));
				}
			});
		} else {
			const encodedEmail = window.btoa(unescape(encodeURIComponent(email)));

			const draftRequestBody = {
				message: {
					raw: encodedEmail
						.replace(/\+/g, '-')
						.replace(/\//g, '_')
						.replace(/=+$/, ''),
				},
			};

			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `https://gmail.googleapis.com/gmail/v1/users/${from}/drafts?key=${process.env.REACT_APP_CLIENT_ID}`,
				data: draftRequestBody,
				headers: {
					Authorization: `Bearer ${localStorage.getItem('gmail_token')}`,
				},
			};

			axios
				.request(config)
				.then(function (response) {
					alert('Drafts Berhasil Disimpan');
					// Optionally, retrieve the draft or perform other actions
				})
				.catch(err => alert('Error saving draft: ' + err));
		}
	};

	const getListDraft = email => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:
				'https://gmail.googleapis.com/gmail/v1/users/' +
				email +
				'/drafts?key=' +
				process.env.REACT_APP_CLIENT_ID,
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('gmail_token'),
			},
		};

		axios
			.request(config)
			.then(function (response) {
				response.data.drafts.map(async draftId => {
					const result = await getDetailThread(
						email,
						draftId?.message?.threadId
					);
					setDraftMsg(prevDraftMsg => [...prevDraftMsg, result]);
				});
			})
			.catch(err => console.error(err));
	};

	const getListMessages = (email, type) => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url:
				'https://gmail.googleapis.com/gmail/v1/users/' +
				email +
				'/messages?labelIds=' +
				type?.toUpperCase() +
				'&maxResults=25&key=' +
				process.env.REACT_APP_CLIENT_ID,
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('gmail_token'),
			},
		};

		axios
			.request(config)
			.then(function (response) {
				if (response.data.messages) {
					getLabels(email);
					response.data.messages.map(async item => {
						const result = await getDetailThread(email, item?.threadId);
						if (type === 'sent') {
							setSentMsg(prevMsg => [...prevMsg, result]);
							setSentFilterMsg(prevMsg => [...prevMsg, result]);
						} else {
							setInboxMsg(prevMsg => [...prevMsg, result]);
							setInboxFilterMsg(prevMsg => [...prevMsg, result]);
						}
					});
				}
			})
			.catch(err => console.error(err));
	};

	const deleteBatch = (email, checked, threadId, typeMsg) => {
		const uniqueArray =
			typeMsg === 'inbox'
				? inboxMsg.filter(
						(item, index, arr) =>
							arr.findIndex(prevItem => prevItem.id === item.id) === index
				  )
				: typeMsg === 'sent'
				? sentMsg.filter(
						(item, index, arr) =>
							arr.findIndex(prevItem => prevItem.id === item.id) === index
				  )
				: draftMsg.filter(
						(item, index, arr) =>
							arr.findIndex(prevItem => prevItem.id === item.id) === index
				  );

		if (email) {
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url:
					'https://gmail.googleapis.com/gmail/v1/users/' +
					email +
					'/messages/batchDelete?key=' +
					process.env.REACT_APP_CLIENT_ID,
				data: {
					ids: checked,
				},
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('gmail_token'),
				},
			};

			axios
				.request(config)
				.then(async function (response) {
					let deleteddata = uniqueArray.filter(
						item => !checked.includes(item.id)
					);
					if (typeMsg === 'inbox') {
						setInboxMsg(deleteddata);
						setInboxFilterMsg(deleteddata);
					} else if (typeMsg === 'sent') {
						setSentMsg(deleteddata);
						setSentFilterMsg(deleteddata);
					} else if (typeMsg === 'draft') {
						setDraftMsg(deleteddata);
						setDraftFilterMsg(deleteddata);
					} else {
						let inboxdata = await inboxMsg.filter(item => item.id !== threadId);
						let sentdata = await sentMsg.filter(item => item.id !== threadId);
						let uniqueDraft = await draftMsg.filter(
							(item, index, arr) =>
								arr.findIndex(prevItem => prevItem.id === item.id) === index
						);
						let draftdata = await uniqueDraft.filter(
							item => item.id !== threadId
						);
						setInboxMsg(inboxdata);
						setSentMsg(sentdata);
						setDraftMsg(draftdata);
						setInboxFilterMsg(draftdata);
						setSentFilterMsg(draftdata);
						setDraftFilterMsg(draftdata);
					}
					alert('data berhasil di hapus');
				})
				.catch(err => alert(err));
		}
	};

	function getHeader(headers, index) {
		let header = '';

		headers.forEach(item => {
			if (item.name === index) {
				header = item.value;
			}
		});

		return header;
	}

	function getBody(message) {
		var encodedBody = '';
		if (typeof message.parts === 'undefined') {
			encodedBody = message.body.data;
		} else {
			encodedBody = getHTMLPart(message.parts);
		}
		encodedBody = encodedBody
			.replace(/-/g, '+')
			.replace(/_/g, '/')
			.replace(/\s/g, '');
		return decodeURIComponent(escape(window.atob(encodedBody)));
	}

	function getHTMLPart(arr) {
		for (var x = 0; x <= arr.length; x++) {
			if (typeof arr[x].parts === 'undefined') {
				if (arr[x].mimeType === 'text/html') {
					return arr[x].body.data;
				}
			} else {
				return getHTMLPart(arr[x].parts);
			}
		}
		return '';
	}

	const handleFilterLabel = (item, type) => {
		if ((type === 'inbox' && item?.id) || type === undefined) {
			const matchedMessages = inboxMsg.filter(message =>
				message.messages.some(msg => msg.labelIds.includes(item.id))
			);
			setInboxFilterMsg(matchedMessages);
			setFilterLabel(item.id);
		} else if (type === 'sent' && item?.id) {
			const matchedMessages = sentMsg.filter(message =>
				message.messages.some(msg => msg.labelIds.includes(item.id))
			);
			setSentFilterMsg(matchedMessages);
			setFilterLabel(item.id);
		} else if (type === 'draft' && item?.id) {
			setFilterLabel(item.id);
			const matchedMessages = draftMsg.filter(message =>
				message.messages.some(msg => msg.labelIds.includes(item.id))
			);
			setDraftFilterMsg(matchedMessages);
		} else {
			setFilterLabel('');
			setInboxFilterMsg(inboxMsg);
			setSentFilterMsg(sentMsg);
			setDraftFilterMsg(draftMsg);
		}
	};

	return (
		<MessageContext.Provider
			value={{
				generateOCRImgToJSON,
				getListThreads,
				inboxMsg,
				setInboxMsg,
				sentMsg,
				setSentMsg,
				getListDraft,
				getLabels,
				draftMsg,
				setDraftMsg,
				getHeader,
				getBody,
				getHTMLPart,
				getListMessages,
				deleteBatch,
				handleToggle,
				checked,
				setChecked,
				toggleAll,
				setToggleAll,
				sendMessage,
				sendDrafts,
				getDetailThread,
				getDetailMessage,
				valueTab,
				setValueTab,
				labelsMsg,
				setLabelsMsg,
				handleFilterLabel,
				filterLabel,
				inboxFilterMsg,
				setInboxFilterMsg,
				sentFilterMsg,
				setSentFilterMsg,
				draftFilterMsg,
				setDraftFilterMsg,
			}}
			{...props}
		/>
	);
};

export default MessageProvider;
